var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "results-container",
      style: { minHeight: _vm.request ? "100px" : undefined },
      attrs: { disabled: _vm.request },
    },
    [
      _vm.request
        ? _c("Spinner", { attrs: { overlay: "", size: "75" } })
        : _vm._e(),
      _vm._v(" "),
      _vm.resultComponentData && _vm.cols && _vm.renderDisplaySettings
        ? [
            _c(
              "div",
              { staticClass: "crumbs-totals" },
              [
                _c("BreadCrumbs", {
                  attrs: { crumbs: _vm.breadCrumbs, disabled: !!_vm.request },
                }),
                _vm._v(" "),
                _c("Totals", {
                  staticClass: "result-totals",
                  attrs: {
                    initialResults: _vm.results,
                    type: _vm.id,
                    indexId: _vm.indexId,
                  },
                  on: {
                    update: function ($event) {
                      _vm.paginationResults = $event
                    },
                  },
                }),
              ],
              1
            ),
            _vm._v(" "),
            !_vm.viewGroup
              ? _c("GroupBy", {
                  attrs: {
                    type: _vm.id,
                    results: _vm.results,
                    disabled: !!_vm.request,
                  },
                })
              : _vm._e(),
            _vm._v(" "),
            _c(
              "div",
              { staticClass: "result-buttons-layout" },
              [
                20 <= (_vm.rows?.rows.length ?? 0)
                  ? _c("Pagination", {
                      attrs: {
                        slot: "pagination",
                        page: _vm.pagination.shownPage,
                        maxPage: _vm.pagination.maxShownPage,
                        disabled: !!_vm.request,
                      },
                      on: {
                        change: function ($event) {
                          _vm.page = $event
                        },
                      },
                      slot: "pagination",
                    })
                  : _vm._e(),
                _vm._v(" "),
                _vm.isGroups
                  ? _c(
                      "div",
                      {
                        staticClass: "btn-group",
                        staticStyle: { flex: "none" },
                      },
                      _vm._l(_vm.cols.groupModeOptions, function (option) {
                        return _c(
                          "button",
                          {
                            key: option,
                            class: [
                              "btn btn-default btn-sm",
                              {
                                active:
                                  _vm.renderDisplaySettings.groupDisplayMode ===
                                  option,
                              },
                            ],
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                _vm.groupDisplayMode = option
                              },
                            },
                          },
                          [_vm._v(_vm._s(option))]
                        )
                      }),
                      0
                    )
                  : _vm._e(),
                _vm._v(" "),
                _vm.viewGroup
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-sm btn-primary",
                        on: { click: _vm.leaveViewgroup },
                      },
                      [
                        _c("span", { staticClass: "fa fa-angle-double-left" }),
                        _vm._v(
                          " " +
                            _vm._s(
                              _vm.$t(
                                "results.resultsView.navigation.backToGroupedResults"
                              )
                            ) +
                            "\n\t\t\t"
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("div", { staticStyle: { "flex-grow": "1" } }),
                _vm._v(" "),
                _vm.concordanceAnnotationOptions.length > 1 && _vm.id === "hits"
                  ? _c("div", [
                      _c("label", [
                        _vm._v(
                          _vm._s(
                            _vm.$t("results.resultsView.selectAnnotation")
                          ) + ": "
                        ),
                      ]),
                      _vm._v(" "),
                      _c(
                        "div",
                        { staticClass: "btn-group" },
                        _vm._l(_vm.concordanceAnnotationOptions, function (a) {
                          return _c(
                            "button",
                            {
                              staticClass: "btn btn-default btn-sm",
                              class: {
                                active: a.id === _vm.concordanceAnnotationId,
                              },
                              attrs: { type: "button" },
                              on: {
                                click: function ($event) {
                                  _vm.concordanceAnnotationId = a.id
                                },
                              },
                            },
                            [_vm._v(_vm._s(_vm.$tAnnotDisplayName(a)))]
                          )
                        }),
                        0
                      ),
                    ])
                  : _vm._e(),
              ],
              1
            ),
            _vm._v(" "),
            _c("GenericTable", {
              class: _vm.isHits
                ? "hits-table"
                : _vm.isDocs
                ? "docs-table"
                : _vm.isGroups
                ? "groups-table"
                : "",
              attrs: {
                type: _vm.id,
                cols: _vm.cols,
                rows: _vm.rows,
                info: _vm.renderDisplaySettings,
                header: _vm.isHits
                  ? _vm.cols.hitColumns
                  : _vm.isDocs
                  ? _vm.cols.docColumns
                  : _vm.cols.groupColumns,
                showTitles: _vm.showTitles,
                disabled: !!_vm.request,
                query: _vm.results?.summary.searchParam,
              },
              on: {
                changeSort: function ($event) {
                  _vm.sort = _vm.sort === $event ? `-${_vm.sort}` : $event
                },
                viewgroup: _vm.changeViewGroup,
              },
            }),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass: "result-buttons-layout",
                staticStyle: {
                  "border-top": "1px solid #ccc",
                  "padding-top": "15px",
                },
              },
              [
                _c("Pagination", {
                  staticStyle: { display: "block" },
                  attrs: {
                    page: _vm.pagination.shownPage,
                    maxPage: _vm.pagination.maxShownPage,
                    disabled: !!_vm.request,
                  },
                  on: {
                    change: function ($event) {
                      _vm.page = $event
                    },
                  },
                }),
                _vm._v(" "),
                _c("div", { staticStyle: { "flex-grow": "1" } }),
                _vm._v(" "),
                _vm.isHits
                  ? _c(
                      "button",
                      {
                        staticClass: "btn btn-primary btn-sm show-titles",
                        attrs: { type: "button" },
                        on: {
                          click: function ($event) {
                            _vm.showTitles = !_vm.showTitles
                          },
                        },
                      },
                      [
                        _vm._v(
                          "\n\t\t\t\t" +
                            _vm._s(
                              _vm.showTitles
                                ? _vm.$t("results.table.hide")
                                : _vm.$t("results.table.show")
                            ) +
                            " " +
                            _vm._s(_vm.$t("results.table.titles")) +
                            "\n\t\t\t"
                        ),
                      ]
                    )
                  : _vm._e(),
                _vm._v(" "),
                _c("Sort", {
                  attrs: {
                    hits: _vm.isHits,
                    docs: _vm.isDocs,
                    groups: _vm.isGroups,
                    parallelCorpus: _vm.isParallelCorpus,
                    corpus: _vm.corpus,
                    annotations: _vm.sortAnnotations,
                    metadata: _vm.sortMetadata,
                    disabled: !!_vm.request,
                  },
                  model: {
                    value: _vm.sort,
                    callback: function ($$v) {
                      _vm.sort = $$v
                    },
                    expression: "sort",
                  },
                }),
                _vm._v(" "),
                _vm.exportEnabled
                  ? _c("Export", {
                      attrs: {
                        results: _vm.results,
                        type: _vm.id,
                        disabled: !!_vm.request,
                        annotations: _vm.exportAnnotations,
                        metadata: _vm.exportMetadata,
                      },
                    })
                  : _vm._e(),
              ],
              1
            ),
          ]
        : _vm.results
        ? _c("div", { staticClass: "no-results-found" }, [
            _vm._v(_vm._s(_vm.$t("results.resultsView.noResultsFound"))),
          ])
        : !_vm.valid
        ? _c("div", { staticClass: "no-results-found" }, [
            _vm._v(
              "\n\t\t" +
                _vm._s(_vm.$t("results.resultsView.inactiveView")) +
                "\n\t"
            ),
          ])
        : _vm.error != null
        ? _c("div", { staticClass: "no-results-found" }, [
            _c("span", {
              staticClass: "fa fa-exclamation-triangle text-danger",
            }),
            _c("br"),
            _vm._v(" "),
            _c("span", { domProps: { innerHTML: _vm._s(_vm.error) } }),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c("br"),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-default",
                attrs: {
                  type: "button",
                  title: _vm.$t("results.resultsView.tryAgainTitle").toString(),
                },
                on: {
                  click: function ($event) {
                    return _vm.markDirty()
                  },
                },
              },
              [_vm._v(_vm._s(_vm.$t("results.resultsView.tryAgain")))]
            ),
          ])
        : _vm._e(),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }